import i18next from "../../../../i18n";

i18next.addResourceBundle("en", "RequirementTable", {
    success_message: "Requirement updated successfully",
    breadcrumb_frameworks: "Frameworks",
    breadcrumb_frameworks_csrd: "CSRD",
    "breadcrumb_frameworks_evs-2023": "EcoVadis",
});

i18next.addResourceBundle("fr", "RequirementTable", {
    success_message: "Requirement updated successfully",
    breadcrumb_frameworks: "Référentiels",
    breadcrumb_frameworks_csrd: "CSRD",
    "breadcrumb_frameworks_evs-2023": "EcoVadis",
});
